import React from 'react'
import '../Scss/PropertyDetail.scss'
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ProductImageSlider from '../Components/ProductImageSlider'
import { Formik, Form, Field } from 'formik';
import {properties} from '../data.js'
import Banner from '../Components/Banner';

const PropertyDetail = () =>{
    const property = properties[0]

    return (
        <React.Fragment>
           <Banner>
                <h2>MODERN APARTMENT IN THE CITY CENTER</h2>
                <p><LocationOnIcon /> 109 Wilton St, New Hyde Park, NY 11040</p>
            </Banner>
            
            
            <div className="property-detail-container container pb-5">
                <ul className="detail-price-mobile">
                    <li>$1300/month</li>
                    <li><PhoneIcon /> (917) 680-2883</li>
                    <li><LocationOnIcon /> See Map</li>
                    <li><FavoriteIcon />Add to favorite</li>
                </ul>
                <div className="row mt-3">
                    <div className="col-lg-9">
                         <ProductImageSlider images={property.images} />
                         
                         <div className="detail-infos">
                            <ul>
                                <li>
                                    <strong>Property type: </strong> Apartment
                                </li>
                                <li>
                                    <strong>Rental type: </strong> Long term rental
                                </li>
                                <li>
                                    <strong>Bedrooms: </strong> 2
                                </li>
                                <li>
                                    <strong>Bathroom: </strong> 1
                                </li>
                                <li>
                                    <strong>Kitchen: </strong> 1
                                </li>
                                <li>
                                    <strong>Parking Space: </strong> 0
                                </li>
                            </ul>
                        </div>
                        <div className="detail-features mt-4">
                             <h4>FEATURES</h4>
                            <ul>
                               <li>Attic</li>
                               <li>Dishwasher</li>
                               <li>Fireplace</li>
                               <li>Garden</li>
                               <li>Gym</li>
                               <li>High ceilings</li>
                               <li>Microwave</li>
                               <li>Patio</li>
                            </ul>
                        </div>
                        <div className="detail-details mt-4">
                             <h4>DETAILS</h4>
                            <p>How the adventure ended will be seen anon. Aouda was anxious, though she said nothing. As for Passepartout, he thought Mr. Fogg’s manoeuvre simply glorious. The captain had said “between eleven and twelve knots,” and the Henrietta confirmed his prediction.</p>
                            <p>If, then—for there were “ifs” still—the sea did not become too boisterous, if the wind did not veer round to the east, if no accident happened to the boat or its machinery, the Henrietta might cross the three thousand miles from New York to Liverpool in the nine days, between the 12th and the 21st of December. It is true that, once arrived, the affair on board the Henrietta, added to that of the Bank of England, might create more difficulties for Mr. Fogg than he imagined or could desire.</p>
                            <p>During the first days, they went along smoothly enough. The sea was not very unpropitious, the wind seemed stationary in the north-east, the sails were hoisted, and the Henrietta ploughed across the waves like a real trans-Atlantic steamer.</p>
                        </div>
                    </div>
                    <div className="col-lg-3 side-bar pl-3">
                         <ul className="detail-price">
                            <li>$1300/month</li>
                            <li><PhoneIcon /> (917) 680-2883</li>
                            <li><LocationOnIcon /> See Map</li>
                            <li><FavoriteIcon />Add to favorite</li>
                         </ul>
                         <br />
                         <ul className="detail-agent">
                             <li><img src="/images/agent1.jpg" /></li>
                             <li><h5>Adam Jarod</h5></li>
                             <li><PhoneIcon /> <small>(917) 680-2883</small></li>
                             <li><MailOutlineIcon /> <small>linxiao0106@gmail.com</small></li>
                             <li><FacebookIcon /><InstagramIcon /><TwitterIcon /><LinkedInIcon /></li>
                             <li><button className="btn btn-danger">All By Adam Jarod</button></li>
                         </ul>
                         <Formik
                            initialValues={{
                               name: '',
                               phoneNumber: '',
                               email: '',
                               message: ''
                            }}

                            onSubmit={async(data,{setSubmitting}) => {
                                setSubmitting(true);
                                
                                //onsubmit function
                                

                                setSubmitting(false);
                            }}
                        >
                            {({ isSubmitting, values }) => (
                                
                                <Form className="detail-send-message mt-3">
                                    <h4>Send Message</h4>
                                    <div className="form-group">
                                        <Field 
                                            name='name'
                                            className="form-control"
                                            type="text"
                                            as='input'
                                            placeholder="Name"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Field 
                                            name='phoneNumber'
                                            className="form-control"
                                            type="text"
                                            as='input'
                                            placeholder="Phone Number"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Field 
                                            name='email'
                                            className="form-control"
                                            type="text"
                                            as='input'
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <Field 
                                            name='message'
                                            className="form-control"
                                            type="text"
                                            as='textarea'
                                            placeholder="Message"
                                            rows="5"
                                        />
                                    </div>
                                    <button className="btn btn-danger">SEND</button>
                                </Form>
                            )}
                        </Formik>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PropertyDetail